import { AddItemModal } from "@/components/AddItemModal";
import { IconButton } from "@ai-teach/ui-web";
import { type RefObject, useEffect, useState } from "react";
import { HiPlus } from "react-icons/hi";
import { MdOutlineUpgrade } from "react-icons/md";

interface StickyAddButtonProps {
  onClick?: () => void;
  parentId?: string | null;
  scrollContainerRef: RefObject<HTMLElement | null>;
}

export function StickyAddButton({ onClick, parentId, scrollContainerRef }: StickyAddButtonProps) {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;
    const handleScroll = () => setShowScrollTop(el.scrollTop > 300);
    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
  }, [scrollContainerRef]);

  const scrollToTop = () => {
    scrollContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-center gap-2">
      {showScrollTop && (
        <IconButton
          aria-label="Scroll to top"
          variant="secondary"
          shape="circle"
          size="md"
          onClick={scrollToTop}
        >
          <MdOutlineUpgrade className="w-5 h-5" aria-hidden="true" />
        </IconButton>
      )}
      {onClick ? (
        <IconButton
          aria-label="Add new item"
          variant="primary"
          shape="circle"
          size="md"
          onClick={onClick}
        >
          <HiPlus className="w-5 h-5" aria-hidden="true" />
        </IconButton>
      ) : (
        <AddItemModal parentId={parentId ?? undefined} dropUp />
      )}
    </div>
  );
}
